const authorizedUserMenus = [
  {
    key: 'profile',
    to: '/settings/profile',
    label: 'header.menu.settings',
  },
  {
    key: 'logout',
    label: 'common.header.menu.logout',
  },
];

const guestUserMenus = [
  {
    key: 'login',
    to: '/login',
    label: 'auth.login',
  },
  {
    key: 'register',
    to: '/register',
    label: 'auth.register',
  },
];

export default function getUserMenus (authorized) {
  return authorized ? authorizedUserMenus : guestUserMenus;
}
